import React from 'react';
import { QuestionToAsk, PrintPage, ReturnToHome } from '../../components';
import { IconWarning } from '@americanexpress/dls-react';

function Error422ForStage2({ apiOutput }) {
    return (
        <>
            <div className="flex flex-justify-center">
                <div className="col-xs-12 text-align-center margin-4-t">
                    <IconWarning
                        size="lg"
                        theme={{
                            color: '#a83025 !important',
                            fill: '#a83025 !important'
                        }}
                    />
                </div>
            </div>
            <div className="col-xs-12 text-align-center">
                <p className="heading-4 pad dls-gray-04">We are sorry</p>
            </div>
            <div className="col-xs-12 text-align-center pad-2">
                <p>We are unable to process your application at this moment. You can continue with the application after
                    sometime by accessing the email that you have received through American Express.</p>
            </div>
            <div className="col-xs-12 text-align-center">
                <p>Application Reference No. {apiOutput.go2ApiPcnNumber}</p>
            </div>
            <div className="col-xs-12 text-align-center">
                <div className="pad-4-t">
                    <ReturnToHome apiOutput={apiOutput} />
                    <PrintPage />
                    <QuestionToAsk />
                </div>
            </div>
        </>
    );
}

export default Error422ForStage2;